import React, { useEffect, useState } from 'react'
import ScannerQR from './ScannerQR'
import MyButton from '../UI/form/MyButton'
import { useDispatch, useSelector } from 'react-redux'
import { setScannerActivate, setScannerOpen, setScannerResult } from '../../store/scannerSlice'
import ScannerQrFlutter from './flutter/ScannerQrFlutter'
import { clearScanedString } from '../../helpers/scan/ScanHelper'
import ScannerQrHid from './ScannerQrHid'

// Компонент потрібен, якщо на сторінці є одночасно кілька сканерів.
// Якщо лише 1 сканер на сторінці, то можна напряму використовувати ScannerQR
const ScannerWrap = ({ setResultText, reset, setReset, isCameraOnly }) => {

    // Сам сканер
    const openScanner = useSelector(state => state.scanner.open)
    const activateScanner = useSelector(state => state.scanner.activate)
    const scanResult = useSelector(state => state.scanner.result)
    // const scanTypeUser = useSelector(state => state.user.user.scanType)

    const dispatch = useDispatch()

    // Дані цього компонента
    const [visibleScanner, setVisibleScanner] = useState(false)
    const [scanResultTemp, setScanResultTemp] = useState('')

    useEffect(() => {
        // Тут прибираю активацію при базовому завантаженні сканеру (при переході на іншу сторінку)
        dispatch(setScannerActivate(false))
    }, [])

    useEffect(() => {
        if (!openScanner) {
            // Додав закриття сканера сюди, щоб встигала закриватись камера після закриття компонента
            setVisibleScanner(false)
        }
    }, [openScanner])

    useEffect(() => {
        result()
    }, [scanResult, visibleScanner])

    useEffect(() => {
        if (reset) { // Якщо треба скинути
            setScanResultTemp('')
            setVisibleScanner(false)
            setReset(false)
        }
    }, [reset])

    const read = () => { // При початку считування
        setVisibleScanner(true)
        dispatch(setScannerResult(''))
        dispatch(setScannerActivate(true))
    }
    
    const close = () => { // Закриття сканера
        dispatch(setScannerOpen(false))
        dispatch(setScannerActivate(false))
        // setVisibleScanner(false) // Прибрав звідси, бо камера не встигала завершуватись перед закриттям компонента
    }

    const result = () => { // При успішному скануванні
        if (scanResult && visibleScanner) {
            setScanResultTemp(clearScanedString(scanResult))
            setResultText(clearScanedString(scanResult))
            close()
        }
    }
        
  return (
    <div>
        {
            !visibleScanner ?
                !scanResultTemp ?
                    <MyButton
                        onClick={read}
                        disabled={openScanner || activateScanner ? true : false}
                    >
                        Активувати сканер
                    </MyButton>
                : ''
            : 
                window.QRInterface ? // Якщо з додатку flutter
                    <ScannerQrFlutter 
                        onClickClose={close}
                        isCameraOnly={isCameraOnly}
                    />
                :
                    <div className='flutterButtons__scan'>
                        <ScannerQR // Якщо просто з браузеру
                            // onClickMy={readMain}
                            onClickClose={close}
                            isCameraOnly={isCameraOnly}
                            // buttonText={'Відкрити сканер'}
                        />
                        <ScannerQrHid 
                            onClickClose={close}
                            isCameraOnly={isCameraOnly}
                        />
                    </div>
        }
    </div>
  )
}

export default ScannerWrap